import { BasePrompt, IBasePromptOptions } from './base-prompt'
import { ControlTypes, Form } from '../'
import { BaseModel } from '../../../data/models'

export interface ISingleRelationshipPromptOptions<T extends BaseModel> extends IBasePromptOptions<string> {
  form: Form<T>
}

export class SingleRelationshipPrompt<T extends BaseModel> extends BasePrompt<string> {
  public controlType = ControlTypes.SingleRelationship
  public form: Form<T> = null

  constructor(options: ISingleRelationshipPromptOptions<T> = { form: null }) {
    super(options)
    this.form = options.form
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/forms/models/prompt/single-relationship-prompt.ts